import { ScrollSliderContext } from '../ScrollSlider.context'

function ScrollSliderProvider({ children, ...restProps }) {
  return <ScrollSliderContext value={restProps}>{children}</ScrollSliderContext>
}

export default ScrollSliderProvider
